export default __webpack_public_path__ + "static/media/pic88.5b2fad65.jpg";